export const ENV_BR = {
  API: {
    TRAVEL: 'https://reservas.viajesexito.com/corp-ms-travel/',
    PROFILE: 'https://reservas.viajesexito.com/corp-ms-profile/',
    RULES: 'https://reservas.viajesexito.com/corp-ms-rule-engine/',
    LOGIN: 'https://v2.dev.rappi.com/api/rocket/login/password/application_user',
    USER: 'https://v2.dev.rappi.com/ms/application-user/auth',
    COUNTRIES: 'https://restcountries.com/v2/',
    LOGIN_EXCHANGE: 'https://v2.dev.rappi.com/api/rocket/exchange/authorization_code',
    RAPPI_SERVICES: 'https://v2.dev.rappi.com/api/',
    RAPPI_SERVICES_CITIES: 'https://v2.dev.rappi.com/api/travel/search/',
    RAPPI_SERVICES_TRAVEL_CITY_SEARCH: 'https://reservas.netactica.com/travel-city-search/',
    NETACTICA_CITIES: 'https://reservas.viajesexito.com/corp-ms-travel/data/AutoComplete/Cities',
    NETACTICA_COUNTRIES: 'https://reservas.viajesexito.com/corp-ms-travel/data/AutoComplete/Countries',
    NETACTICA_PROVINCES: 'https://reservas.viajesexito.com/corp-ms-travel/Travels/GetProvinces',
    RAPPI_SERVICES_TRAVEL_HOTEL_SEARCH: 'https://reservas.viajesexito.com/travel-hotel-search/',
    RAPPI_SERVICES_TRAVEL_HOTEL_SEARCH_OLD:
      'https://reservas.viajesexito.com/NetCoreapi/AutocompleteDestinationStaticContent',
    RAPPI_SERVICES_TRAVEL_HOTEL_CONTENT: 'https://static-content.netactica.net/net/hotel-location/',
    RAPPI_IMAGES_CDN: 'https://images.rappi.com/',
    REACT_APP_SEARCH_MAX_RESULT_PER_PAGE: 10,
  },
  API_KEYS: {
    GOOGLE_MAPS_API_KEY: 'AIzaSyACK5kL1Mx67-XzZPtERXXxDhIkhJBAOoE',
    KUSTOMER_FORM_ID: '5f524de4f0a0d900963139d2',
    AMPLITUDE_KEY: 'f754f0caafc5e6ccf74df0675187d9e5',
  },
  RAPPI_OAUTH: {
    REDIRECT_URL_FROM_LOGIN: 'https://travel-corporate.dev.rappi.com/oauth-login',
    REDIRECT_URL_FROM_REGISTRATION: 'https://travel-corporate.dev.rappi.com/oauth-registration',
    REDIRECT_URL_FROM_INVITE: 'https://travel-corporate.dev.rappi.com/oauth-invite',
    LOGIN_CLIENTID: 'Ax58lfzZNB9PlLcg5npqCHPC4bUUkMR2Nmmt3tYr',
    LOGIN_URL:
      'https://reservas.viajesexito.com/ns-login/es/exito?redirectUrl=https://reservas.viajesexito.com/corporate/auth&continue=https://reservas.viajesexito.com/corporate/booking',
    SIGNUP_URL: 'https://www.dev.rappi.com/login-legacy/signup',
  },
  LANDING_PAGE: 'https://travel4business.dev.rappi.com/',
  SENTRY_DSN: 'https://fe011ed6ec14461595fd1716c48e310d@o484725.ingest.sentry.io/5538357',
  SEARCH_MAX_RESULT_PER_PAGE: 10,
  COUNTRY_CODE: 0,
  RAPPI_BRANCH_CODE: '17',
  PUBLIC_URL: 'https://reservas.viajesexito.com/corporate',
  TOKENEX: {
    TOKENEX_ID: 1659850316743359,
    TOKENEX_ORIGIN: 'https://reservas.viajesexito.com',
    TOKENEX_SECRET: 'BDdTUoeEhB5AfecqERPoRcIyHyce6zwAhMYdrGsV',
  },
  NS_LOGIN_URL:
    '{1}/ns-login/es/{0}?redirectUrl={2}/corporate/auth{5}&continue={3}/corporate/{4}',
};
